<div [class]="containerClasses(level())" class="flex relative bg-white" [class.border-0!]="!hasQuantitySourced()">
  <div [class]="background(level())" class="text-center rounded-l-sm w-6 flex flex-col justify-center">
    @for (star of stars(level()); track $index) {
      <app-icons icon="star"/>
    }
  </div>

  <div class="flex justify-around items-center gap-2 flex-1 min-w-0">
    <div class="shrink-0">
      <app-item-image [item]="item()" width="65" height="65"/>
    </div>

    <div class="min-w-0 flex-1">
      <div class="font-semibold truncate">{{ item().brand }}</div>
      <div class="text-gray-default text-sm">
        <div class="truncate">{{ item().model }}</div>
        <div class="flex gap-2 items-center">
          <div class="grid grid-cols-4 gap-2 shrink-0">
            @for (badge of orderedBadges(); track badge.type) {
              <div>
                <app-badge [variant]="badge.variant">
                  <span class="grid grid-cols-[auto_auto] gap-1 justify-items-center">
                    <span>{{ badge.data.total }}</span>
                    <app-icons [icon]="badge.icon" svgClass=""/>
                  </span>
                </app-badge>
              </div>
            }
          </div>
        </div>

        <div class="truncate">
          @if (item().sourcing.length) {
            @if (resultsStore.isAddonsPending() && !pricing()) {
              <app-spinner size="sm"></app-spinner>
            } @else {
              <div class="space-x-1">
                <span class="font-semibold">{{ pricing() | currency }}</span>
                <span class="text-2xs">out the door</span>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>

  <span class="cursor-pointer text-sm font-regular absolute top-0 right-4" (click)="openSupplierModal()" title="Open supplier selection">
    <app-icons icon="file-pen" width="14"/>
  </span>

  <span class="text-danger cursor-pointer text-sm font-regular z-20 absolute top-0 right-1" (click)="remove()" title="Remove from compare">
    <app-icons icon="times" width="10"/>
  </span>

  @if (!hasQuantitySourced()) {
    <div class="absolute inset-0 bg-white/90 rounded z-10 flex lg:gap-1 items-center justify-center gap-8 border-danger border-2 px-3">
      <div class="text-body shrink-0">
        <app-icons icon="circle-exclamation" width="65"></app-icons>
      </div>

      <div class="flex flex-col flex-1">
        <p class="font-semibold text-sm line-clamp-1">Insufficient Quantity</p>
        <p title="Update suppliers to match quantity" class="text-xs text-body line-clamp-1">Update suppliers to match quantity</p>

        <div class="self-end mt-1">
          <app-button (click)="openSupplierModal()" size="x-small">Edit Suppliers</app-button>
        </div>
      </div>
    </div>
  }
</div>
